import { ReactNode, FC, useRef, useState, useEffect } from "react";
import classes from "./PageContentWrapper.module.css";

const NEAR_BOTTOM_OFFSET = 5;

interface IPageContentWrapperProps {
  children: ReactNode;
  backgroundWindowStyle?: React.CSSProperties;
  layoutStyle?: React.CSSProperties;
  scrollableLayout?: boolean;
  showShadowForScrollableLayout?: boolean;
}

const PageContentWrapper: FC<IPageContentWrapperProps> = ({
  children,
  backgroundWindowStyle,
  layoutStyle,
  scrollableLayout = false,
  showShadowForScrollableLayout = false,
}) => {
  const scrollableRef = useRef<HTMLDivElement>(null);
  const [showShadow, setShowShadow] = useState(false);

  useEffect(() => {
    if (!scrollableLayout) {
      setShowShadow(false);
      return;
    }
    const scrollable = scrollableRef.current;
    if (!scrollable) {
      return;
    }

    const handleScroll = () => {
      const atBottom =
        scrollable.scrollTop + scrollable.clientHeight >= scrollable.scrollHeight - NEAR_BOTTOM_OFFSET;
      setShowShadow(!atBottom);
    };

    handleScroll();

    scrollable.addEventListener("scroll", handleScroll);

    return () => {
      scrollable.removeEventListener("scroll", handleScroll);
    };
  }, [scrollableLayout]);

  return (
    <div className={classes["background-window"]} style={backgroundWindowStyle}>
      <div
        className={`${classes.children} ${scrollableLayout ? classes["scrollable-children"] : ""}`}
        style={layoutStyle}
        ref={scrollableRef}
      >
        {children}
        {scrollableLayout && showShadowForScrollableLayout && (
          <div className={`${classes.shadow} ${showShadow ? "" : classes["shadow-hidden"]}`} />
        )}
      </div>
    </div>
  );
};
export default PageContentWrapper;
